import { AnalyticsChartResponse } from './types';

export const CHART_COLORS = ['#95e5b7', '#e4e6ed'] as const; // 2nd color is filler bar color for percentage bars
const CHART_SINGLE_DATASET_COLOR = '#c5c9d6' as const;

/**
 * Select function to map the analytics chart response data to the data needed for the chart.
 *
 * @param data - The analytics chart response data.
 * @returns The mapped analytics chart data.
 */
export function mapChartData(data: AnalyticsChartResponse) {
  return {
    chartType: data.data.chartType,
    datasets: [data.data.datasets].flat().map((dataset, index) => ({
      backgroundColor:
        data.data.datasets.length > 1
          ? CHART_COLORS[index % CHART_COLORS.length]
          : CHART_SINGLE_DATASET_COLOR,
      data: (dataset.data ?? []).map((dataPoint) => ({
        x: dataPoint.date,
        y: dataPoint.value,
      })),
      label: dataset.label,
    })),
    labels: data.data.labels,
  };
}
